import { render, staticRenderFns } from "./hosting-email-addresses-illustration.vue?vue&type=template&id=87b31924"
import script from "./hosting-email-addresses-illustration.vue?vue&type=script&lang=js"
export * from "./hosting-email-addresses-illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports